module.exports = __webpack_public_path__ + "img/Opplysningstid_palladios-Villa-Rotonda.1c2db294.jpg";